import type { Locale } from "date-fns";
import { enUS, es, ptBR } from "date-fns/locale";

const LOCALE_BY_LANGUAGE: Record<string, Locale> = {
  es,
  en: enUS,
  pt: ptBR,
};

export const DEFAULT_DATE_FNS_LOCALE = es;

export function getDateFnsLocale(locale?: string): Locale {
  const language = locale?.split("-")[0]?.toLowerCase();
  return (language && LOCALE_BY_LANGUAGE[language]) || DEFAULT_DATE_FNS_LOCALE;
}
